export default "__VITE_ASSET__D0sXSZM4__"